import type { IconData } from '@stacksjs/iconify-core'

export const options: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M256 144a64 64 0 1 0-64-64a64.07 64.07 0 0 0 64 64m0-96a32 32 0 1 1-32 32a32.036 32.036 0 0 1 32-32m0 320a64 64 0 1 0 64 64a64.07 64.07 0 0 0-64-64m0 96a32 32 0 1 1 32-32a32.036 32.036 0 0 1-32 32m0-272a64 64 0 1 0 64 64a64.07 64.07 0 0 0-64-64m0 96a32 32 0 1 1 32-32a32.036 32.036 0 0 1-32 32\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default options
